import React, { useState } from 'react';
import './HoverTooltip.css';

const HoverTooltip = ({ children, tooltipText }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className="hover-tooltip-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {isHovered && <div className="tooltip">{tooltipText}</div>}
    </div>
  );
};

export default HoverTooltip;
